import { Drawer, Loader } from 'packages/eid-ui'
import ItemHeader from './ItemHeader'
import { isNilOrEmpty, useIsSmallScreen } from 'packages/core'
import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import CredentialDetails from './CredentialDetails'
import { useCredential } from 'hooks'
import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import InfoBoxMessage from 'packages/eid-ui/InfoBoxMessage'
import { catalogDetailsDrawerExplainProps } from '../catalogDetailsDrawerExplain'

const CredentialDrawer = ({ id, toggleDrawer, attributes }) => {
    const isSmallScreen = useIsSmallScreen()
    const [isEmpty, setIsEmpty] = useState(false)
    const { t } = useTranslation()
    const { data: credential, isFetching } = useCredential(id)

    useEffect(() => {
        if (!isFetching && !credential && !isNilOrEmpty(id)) {
            setIsEmpty(true)
        } else {
            setIsEmpty(false)
        }
    }, [isFetching, credential, id])

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <Box {...catalogDetailsDrawerExplainProps('credential')}>
                <ItemHeader title={credential?.friendlyName} />
                {isEmpty ? (
                    <Box>
                        <InfoBoxMessage message={t('NoAccessToResource')} />
                    </Box>
                ) : (
                    <>
                        {isFetching && <Loader />}
                        {credential && (
                            <CredentialDetails
                                credential={credential}
                                toggleDrawer={toggleDrawer}
                                attributes={attributes}
                            />
                        )}
                    </>
                )}
            </Box>
        </ItemsDetailsMobileWrapper>
    ) : (
        <Drawer
            width="clamp(67%, 1007px, 90%)"
            open={!isNilOrEmpty(id)}
            toggleDrawer={toggleDrawer}
            stickyHeader
            closeOnOutsideClick
            header={<ItemHeader title={credential?.friendlyName} />}
        >
            <Box {...catalogDetailsDrawerExplainProps('credential')}>
                {isEmpty ? (
                    <Box
                        sx={{
                            padding: '10rem',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <InfoBoxMessage message={t('NoAccessToResource')} />
                    </Box>
                ) : (
                    <>
                        {!credential && <Loader />}
                        {credential && (
                            <CredentialDetails
                                credential={credential}
                                toggleDrawer={toggleDrawer}
                            />
                        )}
                    </>
                )}
            </Box>
        </Drawer>
    )
}

export default CredentialDrawer
